import { render, staticRenderFns } from "./LoadCircle.vue?vue&type=template&id=a8c3ef70&scoped=true"
var script = {}
import style0 from "./LoadCircle.vue?vue&type=style&index=0&id=a8c3ef70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c3ef70",
  null
  
)

export default component.exports